import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import './companyform.css';

import Layout from 'components/global/Layout/Layout';
import CompanyForm from 'components/companyform/CompanyForm/CompanyForm';

class CompanyFormPage extends React.Component {
  state = {
    blogPosts: null
  };

  componentDidMount() {
    const postQuery = `https://blog.talenttribe.asia/wp-json/wp/v2/posts?_embed&per_page=100`;
    fetch(postQuery)
      .then((postResponse) => {
        return postResponse.json();
      })
      .then((result) => {
        this.setState({ blogPosts: result });
      });
  }

  render() {
    const { location } = this.props;

    return (
      <Layout>
        <div className='CompanyFormPage-root'>
          <CompanyForm companyKey={location.search.split('=')[1]} blogPosts={this.state.blogPosts} />
        </div>
      </Layout>
    );
  }
}

const connectedCompanyFormPage = connect()(CompanyFormPage);

const wrappedCompanyFormPage = firebaseConnect()(connectedCompanyFormPage);

export default wrappedCompanyFormPage;



// WEBPACK FOOTER //
// ./src/routes/companyform/companyform.js